<template>
  <app-dropdown>
    <template v-slot:dropdown-button>
      <i class="flag-icon" :class="flagIcon"></i>
    </template>
    <template v-slot:dropdown-menu>
      <a
          class="dropdown-item"
          :class="{'active': selectedLanguage === language.key}"
          @click="changeLanguage(language.key)"
          v-for="language in languages"
          v-bind:key="language.key"
      >
        <i class="flag-icon mr-2" :class="language.flag"></i>
        {{ $t(language.label) }}
      </a>
    </template>
  </app-dropdown>
</template>

<script>
import Dropdown from '../../../../components/dropdown/dropdown.vue';

export default {
  name: 'languages-dropdown',
  components: {
    'app-dropdown': Dropdown
  },
  data() {
    return {
      selectedLanguage: null,
    }
  },
  mounted() {
    this.selectedLanguage = this.$i18n.locale;
  },
  unmounted() {
  },
  computed: {
    flagIcon() {
      if (this.selectedLanguage === 'de') {
        return 'flag-icon-de';
      }
      if (this.selectedLanguage === 'fr') {
        return 'flag-icon-fr';
      }
      if (this.selectedLanguage === 'es') {
        return 'flag-icon-es';
      }
      if (this.selectedLanguage === 'jp') {
        return 'flag-icon-jp';
      }
      if (this.selectedLanguage === 'ru') {
        return 'flag-icon-ru';
      }
      return 'flag-icon-us';
    },
    languages() {
      let languages = [
        {
          key: 'en',
          flag: 'flag-icon-us',
          label: 'languages.english'
        },
        {
          key: 'es',
          flag: 'flag-icon-es',
          label: 'languages.spanish'
        },
        {
          key: 'jp',
          flag: 'flag-icon-jp',
          label: 'languages.japanese'
        },
        {
          key: 'ru',
          flag: 'flag-icon-ru',
          label: 'languages.russian'
        },
      ];

      if (this.isDebugEnabled) {
        languages.push({
              key: 'debug',
              flag: '',
              label: 'debug'
            },
        )
      }

      return languages;
    }
  },
  methods: {
    changeLanguage(langCode) {
      if (this.$i18n.locale !== langCode) {
        this.$i18n.locale = langCode;
        this.selectedLanguage = langCode;
      }
    }
  }
}

</script>
<style scoped>
.dropdown-item {
  cursor: pointer;
}
</style>
